


































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class FooterButton extends Vue {
  @Prop() HideProgressBar!: false;
  @Prop() HideBackButton!: false;
  @Prop() PercentDone!: 0;
  @Prop() ButtonDisabled!: true;
  @Prop() IsLoading!: false;
  @Prop() TextDirection!: string;

  nextButtonClick() {
    if (!this.ButtonDisabled) {
      this.$emit("nextPage");
    }
  }

  async mounted(): Promise<void> {
    this.postNavigatedToParent();
  }

  reverseDirection(): boolean {
    return this.TextDirection === 'rtl'
  }

  previousButtonClick() {
    this.$router.go(-1);
  }
  
  // This was added to post a message to the IFrame in wordpress that is hosting this sit.
  // It will enable us to work around a Safari only scrolling issue
  postNavigatedToParent( ) {
    window.parent.postMessage({"data":"ece-navigated"}, "*",);
  }
}
